import {
  REQUEST_TRIP_DETAILS,
  RECEIVE_TRIP_DETAILS,
  TOGGLE_SELECT_BYOR,
  RESET_SELECT_BYOR
} from '../constants/actionTypes';

import { receiveErrorResponse } from './api';

import api from '../api';
import {
  fakeTripDetailsApi3,
  fakeTripDetailsApi3withoutByor
} from '../constants/fakeTripDetails';

export const requestTripDetails = () => ({
  type: REQUEST_TRIP_DETAILS
});

export const receiveTripDetails = response => ({
  type: RECEIVE_TRIP_DETAILS,
  response
});

export const toggleSelectByor = () => ({
  type: TOGGLE_SELECT_BYOR
});

export const resetSelectByor = () => ({
  type: RESET_SELECT_BYOR
});

// For live
export function fetchTripDetails(slug) {
  return function(dispatch) {
    dispatch(requestTripDetails());
    return api
      .get(`/v1/trip/${slug}/detail`)
      .then(response => {
        dispatch(receiveTripDetails(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// For testing
// export function fetchTripDetails(slug) {
//   return function(dispatch) {
//     dispatch(requestTripDetails());
//     return new Promise((resolve, reject) => {
//       setTimeout(resolve, 500);
//     }).then(() => {
//       console.log(slug);
//       if (slug === 'guided-fruit-farm-tour-with-animal-encounters')
//         dispatch(receiveTripDetails(fakeTripDetailsApi3withoutByor));
//       if (slug === 'visit-the-rice-bowl-of-selangor')
//         dispatch(receiveTripDetails(fakeTripDetailsApi3));
//     });
//   };
// }
